
import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollArea } from "@/components/ui/scroll-area";
import { NavigationList } from './NavigationList';
import { NavItemType } from './types';

interface DesktopSidebarProps {
  navItems: NavItemType[];
  isActive: (path: string) => boolean;
  onSignOut: () => void;
}

export function DesktopSidebar({ navItems, isActive, onSignOut }: DesktopSidebarProps) {
  return (
    <aside className="hidden lg:block w-64 border-r bg-background">
      <div className="flex h-14 items-center border-b px-4">
        <Link to="/cms" className="flex items-center font-semibold">
          Agam CMS
        </Link>
      </div>
      <ScrollArea className="h-[calc(100vh-3.5rem)] p-4">
        <NavigationList 
          navItems={navItems}
          isActive={isActive}
          onSignOut={onSignOut}
        />
      </ScrollArea>
    </aside>
  );
}
